// ═══════════════════════════════════════════════════════════
//  Makmal /pipeline-test → tab "Ujian Master Prompt" — butang "Copy Full Output" (2026-10-15)
//  Bina teks untuk SATU kolum: tetapan (model, reasoning, Vision, ayat wajib) + token + kos
//  + output JSON PENUH daripada OpenAI — supaya admin boleh tampal ke ChatGPT untuk banding
//  Low vs Medium. Fungsi tulen (tiada React/Firebase) supaya boleh diuji terus.
//
//  Sumber medan: jawapan `pipelineTestGenerate` mode 'prompt' (functions/index.js):
//    result.meta.{baseline*, optimizedModel, reasoning, verbosity, maxTokens, vision, ayatWajib}
//    col.creative.{raw, rawDipotong, rawPreview, inputTokens, cachedTokens, reasoningTokens,
//                  finishReason, error, vision, ayatWajib} · col.writerOutputTokens · col.totalCostUSD
//  ⚠️ Run lama / function lama tiada `raw` → guna rawPreview (2,000 aksara) DAN tulis amaran
//     dalam teks — jangan salin separuh output secara senyap.
// ═══════════════════════════════════════════════════════════

const nombor = (n) => (Number.isFinite(Number(n)) ? Number(n).toLocaleString('en-US') : '—');
const usd = (n, dp = 4) => (Number.isFinite(Number(n)) ? '$' + Number(n).toFixed(dp) : '—');

/** Output mentah → JSON tersusun kalau boleh dibaca; kalau tidak, teks asal tanpa diubah. */
function susunJson(teks) {
  const t = String(teks || '').trim();
  if (!t) return '';
  try { return JSON.stringify(JSON.parse(t), null, 2); } catch { /* bukan JSON sah — biar asal */ }
  const m = t.match(/\{[\s\S]*\}/);
  if (m) { try { return JSON.stringify(JSON.parse(m[0]), null, 2); } catch { /* biar asal */ } }
  return t;
}

/**
 * @param {object} p
 * @param {object} p.result   jawapan penuh pipelineTestGenerate
 * @param {'kiri'|'kanan'} p.sisi
 * @param {string} [p.namaModule]
 * @param {number} [p.panggilanSehari=2000]
 * @param {number} [p.usdKeMyr]   kadar tukaran untuk anggaran RM (pilihan)
 * @returns {string}
 */
export function binaTeksSalinan({ result, sisi, namaModule = '', panggilanSehari = 2000, usdKeMyr = null }) {
  const meta = result?.meta || {};
  const kanan = sisi === 'kanan';
  const col = kanan ? result?.optimized : result?.current;
  const c = col?.creative || {};

  const model = c.model || (kanan ? meta.optimizedModel : meta.baselineModel) || '—';
  const reasoning = c.reasoning || (kanan ? meta.reasoning : meta.baselineReasoning) || '—';
  const verbosity = (kanan ? meta.verbosity : meta.baselineVerbosity) || '—';
  const maxTokens = kanan ? meta.maxTokens : meta.baselineMaxTokens;
  // Kolum kiri = production: tiada gambar, ayat wajib sentiasa ON.
  const vision = kanan ? (c.vision ?? meta.vision) === true : false;
  const ayatWajib = kanan ? (c.ayatWajib ?? meta.ayatWajib) !== false : true;

  const kos = Number(col?.totalCostUSD);
  const sehari = Number.isFinite(kos) ? kos * panggilanSehari : null;

  let output = c.raw || '';
  let nota = '';
  if (!output && c.rawPreview) {
    output = c.rawPreview;
    nota = '⚠ OUTPUT TIDAK PENUH: run ini hanya ada 2,000 aksara pertama (run lama atau function belum dikemas kini). Jalankan semula untuk output penuh.';
  } else if (c.rawDipotong) {
    nota = '⚠ Output melebihi 60,000 aksara dan DIPOTONG oleh server.';
  }

  const baris = [
    `=== SESAAT Test Lab — Ujian Master Prompt — ${kanan ? 'KOLUM KANAN (master prompt baru)' : 'KOLUM KIRI (production)'} ===`,
    `Module: ${namaModule || meta.moduleId || '—'}`,
    `Produk: ${meta.productName || '—'}`,
    `Model: ${model}`,
    `Reasoning: ${reasoning}`,
    `Verbosity: ${verbosity}`,
    `Max output tokens: ${nombor(maxTokens)}`,
    `Vision (gambar dihantar ke AI): ${vision ? 'ON' : 'OFF'}`,
    `Ayat wajib module: ${ayatWajib ? 'ON' : 'OFF'}`,
    `Token input: ${nombor(c.inputTokens)}${Number(c.cachedTokens) ? ` (+ ${nombor(c.cachedTokens)} dari cache)` : ''}`,
    `Token output: ${nombor(col?.writerOutputTokens)}${c.reasoningTokens != null ? ` (termasuk ${nombor(c.reasoningTokens)} reasoning)` : ''}`,
    `Kos 1 call: ${usd(kos)}`,
    `Unjuran ${nombor(panggilanSehari)} call/hari: ${usd(sehari, 2)} sehari · ${usd(sehari == null ? null : sehari * 30, 2)} sebulan${usdKeMyr && sehari != null ? ` (≈ RM${Math.round(sehari * 30 * usdKeMyr).toLocaleString('en-US')} sebulan)` : ''}`,
    `Finish reason: ${c.finishReason || '—'}`,
  ];
  if (c.error) baris.push(`RALAT: ${c.error}`);
  if (nota) baris.push(nota);
  baris.push('', '--- OUTPUT JSON PENUH DARIPADA OPENAI ---', susunJson(output) || '(kosong — tiada output)');
  return baris.join('\n');
}

/** Salin ke clipboard. Pulang true/false (gagal = beritahu admin, bukan senyap). */
export async function salinKeClipboard(teks) {
  try {
    await navigator.clipboard.writeText(String(teks ?? ''));
    return true;
  } catch {
    try {
      const ta = document.createElement('textarea');
      ta.value = String(teks ?? '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
